<template>
  <div class="container">
    <top num="3"></top>
    <div class="banner">
      <img src="static/img/banner04.png" alt="" />
      <div>
        <p class="title">青铜金融系统</p>
        <p class="desc">服务于拉美人群，普惠金额</p>
      </div>
    </div>
    <div class="main">
      <table></table>
      <p class="title">罗盘风控</p>
      <p class="desc">拉美大数据中心</p>
      <div class="flex">
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 1.3125rem;
          "
        >
          <div class="subtitle">
            <img src="static/img/rect.png" alt="" />
            <p>拉美信用体系</p>
          </div>
          <div class="subtitle">
            <img src="static/img/rect.png" alt="" />
            <p>云计算</p>
          </div>
          <div class="subtitle">
            <img src="static/img/rect.png" alt="" />
            <p>人工智能</p>
          </div>
        </div>
        <img src="static/img/pic06.png" alt="" style="margin: 0 0.1rem" />
        <img src="static/img/pic07.png" alt="" />
      </div>
    </div>
    <div class="main" style="background: rgb(245, 247, 247)">
      <table></table>
      <p class="title">移动支付</p>
      <p class="desc">实现“一码聚合，通收通付”</p>
      <div style="width: 6.35rem; margin: 0 auto">
        <img src="static/img/pic08.png" alt="" class="pic" />
        <p class="intro">
          具备多渠道，多场景整合、差异化服务、商户信息和交易数据自主可控等多项特点。一改传统支付模式，客户只需持智能手机等移动设备，通过扫码即可高效完成支付。同时提供资金对账、技术对接、差错处理、会员账户、运营维护、终端维护等服务，从财务管理、店铺营销、会员管理等多个方面辅助商户经营。
        </p>
        <div class="flexdiv">
          <div>
            <img src="static/img/pic09.png" alt="" />
            <p>提供便捷贴心的生活缴费解决方案</p>
          </div>
          <div>
            <img src="static/img/pic10.png" alt="" />
            <p>酒店收/退押金，轻松退款便捷到账</p>
          </div>
          <div>
            <img src="static/img/pic11.png" alt="" />
            <p>自助设备智能支付</p>
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <table></table>
      <p class="title">拉美科技出海平台</p>
      <p class="desc">金融技术出海，助力拉美移动互联网发展</p>
      <div style="width: 6.35rem; margin: 0 auto">
        <img src="static/img/pic12.png" class="pic" alt="" />
        <div class="flexdiv">
          <div class="block">游戏/工具联运发行</div>
          <div class="block">物联网</div>
          <div class="block">智慧停车</div>
          <div class="block">智慧生活</div>
        </div>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>
<script>
import Bottom from "./bottom.vue";
import top from "./top.vue";
export default {
  components: { top, Bottom },
  name: "cpintro",
  data() {
    return {};
  },
};
</script>
<style scoped>
img {
  display: block;
}
.banner img {
  width: 100%;
}
.banner {
  position: relative;
  color: white;
}
.banner > div {
  position: absolute;
  top: 0.7rem;
  left: 1.66rem;
}
.banner .title {
  font-size: 0.3125rem;
  font-weight: bold;
}
.banner .desc {
  font-size: 0.145833rem;
  margin-top: 0.2rem;
}
.main {
  padding-bottom: 0.78125rem;
}
.main .title {
  font-size: 0.197917rem;
  font-weight: bold;
  text-align: center;
  margin-top: 0.703125rem;
}
.main .desc {
  font-size: 0.104166rem;
  margin-top: 0.145833rem;
  margin-bottom: 0.364583rem;
  text-align: center;
}
.flex {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}
.flex .subtitle {
  position: relative;
  width: 1.692708rem;
}
.flex .subtitle img {
  width: 100%;
}
.flex .subtitle p {
  position: absolute;
  color: white;
  font-size: 0.135416rem;
  text-align: center;
  width: 95%;
  top: 0.08rem;
  left: 0;
}
.flex img {
  width: 1.989583rem;
}
.pic {
  width: 100%;
  margin-bottom: 0.182291rem;
}
.intro {
  font-size: 0.104166rem;
  margin-bottom: 0.416666rem;
}
.flexdiv {
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: center;
}
.flexdiv img {
  width: 1.770833rem;
  margin: 0.15625rem auto;
  margin-top: 0;
}
.block {
  width: 1.25rem;
  height: 0.28125rem;
  line-height: 0.28125rem;
  text-align: center;
  font-size: 0.104166rem;
  background: rgb(240, 240, 240);
}
</style>


// WEBPACK FOOTER //
// src/components/cpintro.vue